import { render, staticRenderFns } from "./SelectDormRoom.vue?vue&type=template&id=63144b5e&scoped=true"
import script from "./SelectDormRoom.vue?vue&type=script&lang=js"
export * from "./SelectDormRoom.vue?vue&type=script&lang=js"
import style0 from "./SelectDormRoom.vue?vue&type=style&index=0&id=63144b5e&prod&scoped=true&xml%3Alang=scss&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63144b5e",
  null
  
)

export default component.exports